(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dbm-stock-info]');
    var anyOpen = document.querySelector('.dbm-stock__tip[data-open="true"]');

    if (btn) {
      e.preventDefault();
      var tip = btn.parentElement.querySelector('.dbm-stock__tip');
      if (!tip) return;
      var willOpen = tip.getAttribute('data-open') !== 'true';
      if (anyOpen && anyOpen !== tip) anyOpen.setAttribute('data-open', 'false');
      tip.setAttribute('data-open', willOpen ? 'true' : 'false');
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (anyOpen && !e.target.closest('.dbm-stock__tip')) {
      anyOpen.setAttribute('data-open', 'false');
      var related = document.querySelector('[data-dbm-stock-info][aria-expanded="true"]');
      if (related) related.setAttribute('aria-expanded', 'false');
    }
  });
})();
